/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleListResponse {
    getFixupPrototypeFunction() { return RoleListResponse.fixupPrototype; }

    static newInstance(model: Partial<RoleListResponse>): RoleListResponse {
        let obj = Object.assign(new RoleListResponse(), model);
        RoleListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleListResponse>): RoleListResponse {
        if (!model) return null;
        return RoleListResponse.newInstance(<RoleListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleListResponse) {
        if (!obj) return;

        models.RoleListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleListResponse): boolean {
        Object.setPrototypeOf(obj, RoleListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.roles) {
            for (let val of this.roles) {
                models.RoleDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Total number of roles available in the specific tenant
     */
    total_count: number;

    /**
     * List of roles available in specific tenant
     */
    roles: Array<models.RoleDetails>;

}
